import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { FormGroup, Button, Intent, TextArea } from "@blueprintjs/core";
import GeoComplete from 'helpers/GeoComplete';
import Toast from 'helpers/toaster';
import FormDrawer from 'components/FormDrawer';
import { FormSection, FieldError, MoreOptions } from 'components/FormBits';

const ADDRESS_ID = 'new-location-address';
// Geosuggest puts `id` on its wrapper and derives the input's id from it.
const ADDRESS_INPUT_ID = `geosuggest__input--${ADDRESS_ID}`;

@inject('clientStore') @observer
class AddLocationModal extends Component {

  @observable initialLocation = '';
  @observable error = null;

  // Closing without saving forgets the picked address (and its client), so a
  // later Add location on another client can't save it for this one.
  handleCloseLocationDailog() {
    this.error = null;
    if (this.props.clientStore && this.props.clientStore.clearLocationObject) {
      this.props.clientStore.clearLocationObject();
    }
    this.props.onClose()
  }

  onAddressSelect(suggestion) {
    let {
      props: {
        clientStore: {
          location: {
            object
          }
        }
      }
    } = this;
    if(suggestion) {
      object.full_address = suggestion.label;
      object.latitude = suggestion.location.lat;
      object.longitude = suggestion.location.lng;
      object.place_id = suggestion.placeId;
      object.client_id = this.props.client_id;
      this.error = null;
    } else {
      object.full_address = null;
      object.latitude = null;
      object.longitude = null;
      object.place_id = null;
    }
  }

  onAddressClear(value) {
    let {
      props: {
        clientStore: {
          location: {
            object
          }
        }
      }
    } = this;
    if(!value) {
      object.full_address = null;
      object.latitude = null;
      object.longitude = null;
      object.place_id = null;
    }
  }

  createLocation() {
    let {
      props: {
        clientStore: {
          location: {
            object
          }
        }
      }
    } = this;
    if(!object.full_address) {
      this.error = 'Search for the address and pick it from the list.';
      const input = document.getElementById(ADDRESS_INPUT_ID);
      if (input) {
        input.focus();
        input.scrollIntoView({ block: 'center' });
      }
      return;
    }

    this.props.clientStore.createLocation()
      .then(this.onSuccessfulAddLocation.bind(this))
      .catch(this.onFailAddLocation.bind(this))
  }

  onSuccessfulAddLocation(response) {
    this.props.onSuccess(response.data.data)
  }

  onFailAddLocation(error) {
    const errors = error && error.response && error.response.data && error.response.data.errors;
    Toast.show({
      icon: 'warning-sign',
      message: Array.isArray(errors) && errors.length ? errors.join(', ') : 'Unable to add this location. Please try again.',
      intent: Intent.DANGER
    });
    console.log(error);
  }

  render() {
    const { isLoading } = this.props.clientStore.location;
    const object = this.props.clientStore.location.object || {};
    const close = this.handleCloseLocationDailog.bind(this);
    return(
      <FormDrawer
        isOpen={this.props.isOpen}
        title="Add location"
        icon="map-marker"
        onClose={close}
        busy={isLoading}
        footer={
          <>
            <Button text="Cancel" onClick={close} disabled={isLoading} />
            <Button
              intent={Intent.PRIMARY}
              icon="add"
              text="Add location"
              loading={isLoading}
              onClick={this.createLocation.bind(this)}
            />
          </>
        }
      >
        <FormSection title="Address" hint="Search, then pick the address from the list so it lands on the map.">
          <FormGroup
            label="Address"
            labelFor={ADDRESS_INPUT_ID}
            labelInfo={<span className="fb-required" aria-hidden="true">*</span>}
            className={this.error ? 'has-error' : undefined}
          >
            <GeoComplete
              id={ADDRESS_ID}
              placeholder="e.g. 12 Main St, Springfield"
              autoFocus={true}
              initialValue={this.initialLocation}
              onSuggestSelect={this.onAddressSelect.bind(this)}
              onChange={this.onAddressClear.bind(this)}
            />
            <FieldError id={`${ADDRESS_ID}-error`}>{this.error}</FieldError>
          </FormGroup>

          <MoreOptions label="Notes for this location" open={Boolean(object.notes)}>
            <FormGroup label="Notes" labelFor="new-location-notes">
              <TextArea
                id="new-location-notes"
                className="bp3-fill"
                placeholder="e.g. Unit 4B, side door; dog in the yard"
                rows={3}
                value={object.notes || ''}
                onChange={(event) => { object.notes = event.target.value } }
              />
            </FormGroup>
          </MoreOptions>
        </FormSection>
      </FormDrawer>
    )
  }

};

export default AddLocationModal;